export function filterEvents(events, startDate, endDate) {
  if (!events) {
    return
  }

  const shouldFilter = startDate && endDate

  if (shouldFilter) {
    events = events.filter(event => {
      const time = Date.parse(event.event_timestamp)
      const start = Date.parse(startDate)
      const end = Date.parse(endDate)

      if (time > start && time < end) {
        return event
      }
    })
  }
  return events
}
